import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const DHTML = () => {
  return (
    <StartInterviewLayout type="dhtml"/>
  )
}

export default DHTML;